export default __webpack_public_path__ + "static/media/shape3mobile.14c22dba.svg";